export default "__VITE_ASSET__ummCYMt6__"